import { Component, OnInit, Input, HostListener, Renderer2, OnDestroy, ViewChild, ElementRef, ViewChildren, QueryList, AfterViewInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-video',
  templateUrl: './q-video.component.html',
  styleUrls: ['./q-video.component.css'],
})

export class VideoComponent implements OnInit, OnDestroy, AfterViewInit {

  //#region propriétés publics

  public video: HTMLVideoElement;

  public inputHeight: number | null = 100;
  public inputWidth: number | null = 100;

  public _width: number = 100;
  public _height: number = 100;
  public containerWidth: number;
  public containerHeight: number;

  public selectedOptionPanel: string = 'default';
  public hoverTime: number = 0;

  public isVideoContainerLoaded: boolean = false;
  public isMoreOptionsVisible: boolean = false;
  public isPlaying: boolean = false;
  public isFirstPlaying: boolean = true;
  public isFullScreen: boolean = false;
  public isControlBarHover: boolean = false;
  public isEnded: boolean = false;

  public previousActiveElement: any = null;
  //#enregion

  //#region propriétés privées
  private canvasContext: CanvasRenderingContext2D;
  private interval: any;

  private mouseMooving: boolean = false;

  private _src: string = 'https://www.queoval.fr/QueovalStreamWS/videos/Queoval/483938.mp4';
  private _preview: string = '';

  private isPercentWidth: boolean = true;
  private isPercentHeight: boolean = true;
  //#endregion


  //#region Inputs
  @Input('preview')
  set SetPreview(value: string) {
    if (value) {
      this._preview = value;
    }
  }

  @Input('src')
  set SetUrl(value: string) {
    if (value) {
      this._src = value;
    }
  }

  @Input('width')
  set SetWidth(value: string) {
    if (value && (value.includes('px') || value.includes('%'))) {
      if (value.includes('px')) {
        this.isPercentWidth = false;
        this._width = parseInt(value.replace('px', ''));
      } else if (value.includes('%')) {
        this.isPercentWidth = true;
        this.inputWidth = parseInt(value.replace('%', ''));
        this.calculWidthSize(false);
      }
    }
  }


  @Input('height')
  set SetHeight(value: string) {
    if (value && (value.includes('px') || value.includes('%'))) {
      if (value.includes('px')) {
        this.isPercentHeight = false;
        this._height = parseInt(value.replace('px', ''));

      } else if (value.includes('%')) {
        this.isPercentHeight = true;
        this.inputHeight = parseInt(value.replace('%', ''));
        this.calculHeightSize(false);
      }
    }
  }
  //#endregion

  //#region viewChild/viewChildren
  @ViewChild('VideoContainer', { static: false }) videoContainer: ElementRef;
  @ViewChild('ControlBarContainer', { static: false }) ControlBarContainer: ElementRef;
  @ViewChild('Canvas', { static: false }) canvas: ElementRef;
  @ViewChild('slider', { static: false }) slider: ElementRef;
  @ViewChild('inputVolume', { static: false }) inputVolume: ElementRef;
  @ViewChild('sliderTitle', { static: false }) sliderTitle: ElementRef;
  @ViewChildren('rangeEl') rangeEl: QueryList<ElementRef>;
  //#endregion

  //#region listenners

  //plein écran
  //#region gestion multi-navigateurs
  @HostListener('webkitfullscreenchange', ['$event'])
  @HostListener('mozfullscreenchange', ['$event'])
  @HostListener('MSFullscreenChange', ['$event'])
  //#endregion
  @HostListener('fullscreenchange', ['$event'])
  screenChange(event: any) {
    if (document.fullscreenElement === null) {
      setTimeout(() => {
        this.containerWidth = this.videoContainer.nativeElement.offsetWidth;
        this.containerHeight = this.videoContainer.nativeElement.offsetHeight;
        if (this.isFirstPlaying) {
          this.DrawPreview();
        } else {
          this.CreateCanvas(this.video.currentTime);
        }
      }, 100);

      this.isFullScreen = false;
    }
  }

  //raccourcis clavier
  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if ((this.slider && this.slider.nativeElement === document.activeElement) || (this.inputVolume && this.inputVolume.nativeElement === document.activeElement)) {
      switch (event.key) {
        case 'Spacebar':
        case ' ':
          this.TooglePlay();
          break;
        case "ArrowLeft":
          this.video.currentTime = this.video.currentTime - 10 < 0 ? 0 : this.video.currentTime - 10;
          this.DrawImage();
          break;
        case "ArrowRight":
          this.video.currentTime = this.video.currentTime + 10 > this.video.duration ? this.video.duration : this.video.currentTime + 10;
          this.DrawImage();
          break;
      }
    }
  }

  //contrôle du volume à la roulette
  @HostListener('mousewheel', ['$event'])
  OnWheelling(e: any) {

    if (document.activeElement === this.inputVolume.nativeElement) {
      e.preventDefault()
      const value = e.deltaY * -0.0005;
      if (this.video.volume + value <= 1 && this.video.volume + value >= 0) {
        this.video.volume += value;
        this.updateRangeEl(this.inputVolume.nativeElement);
      } else if (this.video.volume + value > 1) {
        this.video.volume = 1
      } else {
        this.video.volume = 0;
      }
      this.OnVolumeChange(this.video.volume);
    }
  }

  //recalcul des dimensions du lecteur au resize
  @HostListener('window:resize', ['$event'])
  OnResizing(e: any) {

    if (this.inputHeight !== null) {
      this.calculHeightSize(false);
    }
    if (this.inputWidth !== null) {
      this.calculWidthSize(false);
    }
    setTimeout(() => {
      if (this.isFirstPlaying) {
        this.DrawPreview();
      } else {
        this.CreateCanvas(this.video.currentTime);
      }
    }, 100);
  }
  //#endregion listenners

  constructor(
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.video = document.createElement('VIDEO') as HTMLVideoElement;
    this.video.src = this._src;
    this.video.preload = 'metadata';
    this.renderer.listen(this.video, 'loadeddata', () => {
      this.DrawPreview();
    });
    this.renderer.listen(this.video, 'play', () => {
      this.afficherDansCanvas()
    });
    this.renderer.listen(this.video, 'pause', () => {
      window.clearInterval(this.interval);
    });
    this.renderer.listen(this.video, 'ended', () => {
      clearInterval(this.interval);
    });
    this.renderer.listen(this.video, 'progress', () => {
      this.UpdateSliderRange();
    });
    this.renderer.listen(this.video, 'ended', () => {
      this.OnPause();
      this.isEnded = true;
    });
    this.Init();
  }
  ngAfterViewInit(): void {
    var i = setInterval(() => {
      if (this.videoContainer && this.videoContainer.nativeElement) {
        this.isVideoContainerLoaded = true;
        clearInterval(i);
      }
    }, 100);
  }
  ngOnDestroy(): void {
    this.video.pause();
  }

  public TooglePlay(): void {
    if (this.isPlaying) {
      this.OnPause();
      this.AfficheControleBar();
    }
    else {
      this.OnPlay();
    }
  }

  public OnPlay(): void {
    this.isEnded = false;
    this.isFirstPlaying = false;
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.video.play();
    }
  }

  public OnPause(): void {
    if (this.isPlaying) {
      this.isPlaying = false;
      this.video.pause();
      this.AfficheControleBar();
    }
  }

  public ToogleFullScreen(): void {
    // fonction non exécuté dans le cas d'un audio (mp3)
    if (!this.video.src.endsWith('mp3')) {
      if (this.isFullScreen) {
        this.OnCloseFullscreen();
      } else {
        this.OnFullScreen();
      }
    }
  }

  public OnFullScreen(): void {
    this.isControlBarHover = false;
    if (this.videoContainer.nativeElement.webkitRequestFullScreen) {
      this.videoContainer.nativeElement.webkitRequestFullScreen();
    }
    else {
      this.videoContainer.nativeElement.mozRequestFullScreen();
    }
    setTimeout(() => {
      this.containerWidth = this.videoContainer.nativeElement.offsetWidth;
      this.containerHeight = this.videoContainer.nativeElement.offsetHeight;
      if (this.isFirstPlaying) {
        this.DrawPreview();
      } else {
        this.CreateCanvas(this.video.currentTime);
      }
    }, 100);
    this.isFullScreen = true;


  }

  public OnMute(): void {
    this.video.muted = !this.video.muted;
    if (this.video.muted) {
      this.updateRangeEl(this.inputVolume.nativeElement, '#c5c5c5');
    } else {
      this.updateRangeEl(this.inputVolume.nativeElement);
    }
  }
  public OnVolumeChange(value: number): void {
    if (value !== 0) {
      this.video.muted = false;
    }
  }
  public OnSpeedChange(rate: number): void {
    this.video.playbackRate = rate;
    this.selectedOptionPanel = 'default';
  }
  public OnStepCurrentTime(addTime: boolean): void {
    if (addTime) {
      this.video.currentTime = this.video.currentTime + 10 > this.video.duration ? this.video.duration : this.video.currentTime + 10;
    }
    else {
      this.video.currentTime = this.video.currentTime - 10 < 0 ? 0 : this.video.currentTime - 10;
    }
    this.DrawImage();
  }

  public OnCloseFullscreen(): void {
    this.isControlBarHover = false
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }
    else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    }
    else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    }
    else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
  }

  public AfficheMoreOptions(option: boolean) {
    this.isMoreOptionsVisible = option;
    if (!option) {
      this.selectedOptionPanel = 'default';
    }
  }

  public AfficheTitle(event: any): void {
    const sliderOffsetX: number = this.slider.nativeElement.getBoundingClientRect().left - document.documentElement.getBoundingClientRect().left;
    const sliderWidth: number = this.slider.nativeElement.offsetWidth - 1;

    var currentMouseXPos = (event.clientX + window.pageXOffset) - sliderOffsetX;
    var sliderValAtPos = this.video.duration * currentMouseXPos / sliderWidth;
    // this...
    if (sliderValAtPos < 0) sliderValAtPos = 0;
    this.hoverTime = sliderValAtPos;
    this.sliderTitle.nativeElement.style.left = (currentMouseXPos - (this.sliderTitle.nativeElement.offsetWidth * sliderValAtPos / this.video.duration)).toFixed(0) + 'px';
  }

  public AffectTitle(): void {
    this.DrawImage();
    this.video.currentTime = this.hoverTime
  }

  // change le style des curseurs de lecture et de gestion du volume
  public updateRangeEl(rangeEl: any, color: string = 'var(--c-main)') {

    var ratio = ((rangeEl.value - rangeEl.min) / (rangeEl.max - rangeEl.min));

    rangeEl.style.background = [
      'linear-gradient(',
      'to right, ',
      ` ${color} ` + ratio * 100 + '%, ',
      ' #c5c5c5 ' + ratio * 100 + '% 100%',
      ')'
    ].join('');
  }

  public UpdateSliderRange(): void {
    let background: string = '';
    let percentend: number | null = 0;
    let percentstart: number | null = null;
    if (this.slider) {
      for (let i: number = 0; i < this.video.buffered.length; i++) {
        if (this.video.buffered.end(i) > this.video.currentTime) {


          if (percentend && percentstart) {
            percentstart = ((this.video.buffered.start(i) - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;
            if (percentend !== percentstart) {
              background += ` #c5c5c5 ${percentend}% ${percentstart}%,`;
            }
          } else if (this.video.buffered.start(i) > this.video.currentTime) {
            percentstart = ((this.slider.nativeElement.value - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;
            percentend = ((this.video.buffered.start(i) - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;
            background += ` #c5c5c5 ${percentstart}% ${percentend}%,`;
          }

          percentend = ((this.video.buffered.end(i) - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;
          if (this.video.buffered.start(i) > this.video.currentTime) {
            percentstart = ((this.video.buffered.start(i) - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;

            background += ` var(--c-dark-secondary) ${percentstart}% ${percentend}%,`;
          } else {
            percentstart = ((this.slider.nativeElement.value - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min)) * 100;
            background += ` var(--c-dark-secondary) ${percentstart}% ${percentend}%,`;
          }
        }
      }
      let ratio = ((this.slider.nativeElement.value - this.slider.nativeElement.min) / (this.slider.nativeElement.max - this.slider.nativeElement.min));
      ratio = ratio ? ratio : 0;

      this.slider.nativeElement.style.background = [
        'linear-gradient(',
        'to right, ',
        ' var(--c-main) 0% ' + ratio * 100 + '%, ',
        background,
        ' #c5c5c5 ' + percentend + '% 100%',
        ')'
      ].join('');
    }
  }

  public AfficheControleBar(): void {
    this.ControlBarContainer.nativeElement.classList.add("bottom-0");
    this.videoContainer.nativeElement.classList.remove("cursor-none");
    this.mouseMooving = true;
    setTimeout(() => { this.mouseMooving = false; }, 500);
    setTimeout(() => {
      this.HideControleBar();
    }, 3000);
  }

  public HideControleBar(): void {
    if (!this.mouseMooving && this.isPlaying && !this.isControlBarHover && !this.isMoreOptionsVisible) {
      if (this.ControlBarContainer != null) {
        this.ControlBarContainer.nativeElement.classList.remove("bottom-0");
      }
      if (this.videoContainer != null) {
        this.videoContainer.nativeElement.classList.add("cursor-none");
      }
    }
  }

  //#region fonctions de convertion des pourcentages en pixels
  //est utilisé en dehors du composant (dans les composants parents) pour initialiser la dimension du lecteur vidéo en même temps que le conteneur parent
  // NE PAS PASSER la méthode en private. (la laisser en public)
  public calculWidthSize(createCanvas: boolean = true) {
    if (this.videoContainer !== null) {
      if (this.isPercentWidth && this.inputWidth) {
        let parentElem: any = this.videoContainer.nativeElement.parentElement
        if (parentElem) {
          const parentWidth = parentElem.parentElement.clientWidth;
          this._width = parentWidth === null || parentWidth === undefined || parentWidth === 0 ? this._width : parentWidth * this.inputWidth / 100;
          setTimeout(() => {
            this.containerWidth = this.videoContainer.nativeElement.offsetWidth;
            if (createCanvas) {
              if (this.isFirstPlaying) {
                this.DrawPreview();
              } else {
                this.CreateCanvas(this.video.currentTime);
              }
            }
          }, 0)
        }
      }
    }
  }

  //est utilisé en dehors du composant (dans les composants parents) pour initialiser la dimension du lecteur vidéo en même temps que le conteneur parent
  // NE PAS PASSER la méthode en private. (la laisser en public)
  public calculHeightSize(createCanvas: boolean = true) {
    if (this.videoContainer !== null) {
      if (this.isPercentHeight && this.inputHeight) {
        const parentElem: any = this.videoContainer.nativeElement.parentElement
        if (parentElem) {
          const parentHeight = parentElem.parentElement.clientHeight
          this._height = parentHeight === null || parentHeight === undefined || parentHeight === 0 ? this._height : parentHeight * this.inputHeight / 100;
          setTimeout(() => {
            this.containerHeight = this.videoContainer.nativeElement.offsetHeight;
            if (createCanvas) {
              if (this.isFirstPlaying) {
                this.DrawPreview();
              } else {
                this.CreateCanvas(this.video.currentTime);
              }
            }
          }, 0)
        }
      }
    }
  }

  public FocusVolumeInput(): void {
    if (document.activeElement !== this.inputVolume.nativeElement) {
      this.previousActiveElement = document.activeElement;
    }
    this.inputVolume.nativeElement.focus();
  }
  public UnfocusVolumeInput(): void {
    this.previousActiveElement.focus();
  }

  private Init() {
    setTimeout(() => {
      // initialise lorsque l'élément est dans le DOM, sinon rappel l'Init
      if (
        this.canvas && this.canvas.nativeElement &&
        this.videoContainer && this.videoContainer.nativeElement &&
        this.ControlBarContainer && this.ControlBarContainer.nativeElement &&
        this.slider && this.slider.nativeElement &&
        this.sliderTitle && this.sliderTitle.nativeElement &&
        this.rangeEl && this.rangeEl.length > 0
      ) {
        // si la dimension définie est en %age
        if (this.inputWidth != null) {
          this.calculWidthSize(false);
        }
        if (this.inputHeight != null) {
          this.calculHeightSize(false);
        }

        this.renderer.listen(this.videoContainer.nativeElement, 'click', (e: any) => {
          if (e.target !== this.inputVolume.nativeElement) {
            this.slider.nativeElement.focus();
          }
        });

        this.AfficheControleBar();
        this.initRangeEl();
        this.renderer.listen(this.videoContainer.nativeElement, 'resize', () => {
          setTimeout(() => {
            this.containerWidth = this.videoContainer.nativeElement.offsetWidth;
            this.containerHeight = this.videoContainer.nativeElement.offsetHeight;
            if (this.isFirstPlaying) {
              this.DrawPreview();
            } else {
              this.CreateCanvas(this.video.currentTime);
            }
          }, 100);
        });
        setTimeout(() => {
          this.containerWidth = this.videoContainer.nativeElement.offsetWidth;
          this.containerHeight = this.videoContainer.nativeElement.offsetHeight;

          this.video.load();
        }, 100);
      } else {
        this.Init();
      }
    }, 500);
  }

  private initRangeEl() {

    /**
     * IE/Older Edge FIX
     * On IE/Older Edge the height of the <input type="range" />
     * is the whole element as oposed to Chrome/Moz
     * where the height is applied to the track.
     *
     */
    if (this.isOlderEdgeOrIE()) {

      this.rangeEl.forEach((range: ElementRef) => {
        range.nativeElement.style.height = "20px";
      });
      //  // IE 11/10 fires change instead of input
      //  // https://stackoverflow.com/a/50887531/3528132
      //}

    } else {
      this.rangeEl.forEach((range: ElementRef) => {
        this.updateRangeEl(range.nativeElement);
        range.nativeElement.addEventListener("input", (e: any) => {
          this.updateRangeEl(e.target);
        });
      });
    }
  }

  // redéfini les dimensions du canvas (à l'init, au resize, et lors du full screen)
  private CreateCanvas(currentTime: number): void {
    if (this.canvas) {
      this._CreateContext();
      this.video.currentTime = currentTime;
      setTimeout(() => { this.DrawImage(); }, 500);
    }
  }

  private DrawPreview(): void {
    if (this.canvas) {
      this._CreateContext();
      this.video.currentTime = 0;
    }
    if (this._preview) {
      setTimeout(() => {
        const prev: HTMLImageElement = document.createElement('IMG') as HTMLImageElement;
        prev.src = this._preview;
        prev.addEventListener('load', () => {

          // code très largement inspiré de DrawImage() en remplacant this.video par la preview
          let x_of_prev: number = 0;
          let y_of_prev: number = 0;
          this.canvasContext.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
          if (this.canvas.nativeElement.width - prev.naturalWidth != 0 || this.canvas.nativeElement.height - prev.naturalHeight != 0) {
            if (prev.naturalWidth / this.canvas.nativeElement.width < prev.naturalHeight / this.canvas.nativeElement.height) {

              const vRatio: number = (this.canvas.nativeElement.height / prev.naturalHeight) * prev.naturalWidth;
              x_of_prev = (this.canvas.nativeElement.width - vRatio) / 2;
              this.canvasContext.drawImage(prev, x_of_prev, 0, vRatio, this.canvas.nativeElement.height);
            }
            if (prev.naturalHeight / this.canvas.nativeElement.height < prev.naturalWidth / this.canvas.nativeElement.width) {
              const hRatio: number = (this.canvas.nativeElement.width / prev.naturalWidth) * prev.naturalHeight;
              y_of_prev = (this.canvas.nativeElement.height - hRatio) / 2;
              this.canvasContext.drawImage(prev, 0, y_of_prev, this.canvas.nativeElement.width, hRatio);
            }
          }
          else {
            this.canvasContext.drawImage(prev, 0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
          }
        })
      }, 50);
    } else {
      setTimeout(() => { this.DrawImage(); }, 500);
    }
  }

  //créé le context 2D par rapport à la vidéo et au canvas
  private _CreateContext(): void {
    let width: number = this.video.videoWidth;
    let height: number = this.video.videoHeight;
    // si les dimensions du canvas ne sont pas les mêmes que celles de la vidéo
    // la taille du canvas fera :
    // proportionnellement à la vidéo, la plus petite des valeurs entre la width et la height
    // le côté restant (width ou height) redimensionné proportionnellement à la vidéo
    // ex: vidéo: w 500/ h 750 | containerWidth: w 500/ h 600 => width 625 / height 750
    if (this.containerWidth - this.video.videoWidth != 0 || this.containerHeight - this.video.videoHeight != 0) {
      if (this.video.videoWidth / this.containerWidth < this.video.videoHeight / this.containerHeight) {
        width = this.containerWidth * this.video.videoHeight / this.containerHeight;
      }
      if (this.video.videoHeight / this.containerHeight < this.video.videoWidth / this.containerWidth) {
        height = this.containerHeight * this.video.videoWidth / this.containerWidth;
      }
    }

    if (width !== 0 && height !== 0) {
      this.canvas.nativeElement.width = width;
      this.canvas.nativeElement.height = height;
    }
    else {
      this.canvas.nativeElement.width = this._width;
      this.canvas.nativeElement.height = this._height;
    }
    this.canvasContext = this.canvas.nativeElement.getContext("2d") as CanvasRenderingContext2D;
  }

  // fonction principale du dessin de l'image de la vidéo dans le canvas
  private DrawImage(): void {

    let x_of_video: number = 0;
    let y_of_video: number = 0;

    // si le canvas n'a pas les même dimensions que la vidéo
    if (this.canvas.nativeElement.width - this.video.videoWidth != 0 || this.canvas.nativeElement.height - this.video.videoHeight != 0) {

      // SI le container a proportionnellement à la vidéo une width plus petite que la height
      if (this.video.videoWidth / this.canvas.nativeElement.width < this.video.videoHeight / this.canvas.nativeElement.height) {
        // ratio de la width
        const vRatio: number = (this.canvas.nativeElement.height / this.video.videoHeight) * this.video.videoWidth;
        // calcul des marges (bandes noires sur les côtés)
        x_of_video = (this.canvas.nativeElement.width - vRatio) / 2;

        // efface l'image dans les bandes noires (en cas de résidus dus à un resizing)
        this.canvasContext.clearRect(0, 0, x_of_video, this.canvas.nativeElement.height);
        this.canvasContext.clearRect(x_of_video + vRatio, 0, x_of_video, this.canvas.nativeElement.height);
        // dessin de la vidéo redimensionnée dans le canvas avec les marges
        this.canvasContext.drawImage(this.video, x_of_video, 0, vRatio, this.canvas.nativeElement.height);
      }

      // SI le container a proportionnellement à la vidéo une height plus petite que la width
      if (this.video.videoHeight / this.canvas.nativeElement.height < this.video.videoWidth / this.canvas.nativeElement.width) {
        // ratio de la height
        const hRatio: number = (this.canvas.nativeElement.width / this.video.videoWidth) * this.video.videoHeight;
        // calcul des marges (bandes noires au dessus et en dessous)
        y_of_video = (this.canvas.nativeElement.height - hRatio) / 2;

        // efface l'image dans les bandes noires (en cas de résidus dus à un resizing)
        this.canvasContext.clearRect(0, 0, this.canvas.nativeElement.width, y_of_video);
        this.canvasContext.clearRect(0, y_of_video + hRatio, this.canvas.nativeElement.width, y_of_video);
        // dessin de la vidéo redimensionnée dans le canvas avec les marges
        this.canvasContext.drawImage(this.video, 0, y_of_video, this.canvas.nativeElement.width, hRatio);
      }
    }
    else {
      // dessin de la vidéo redimensionnée dans le canvas sans les marges si le canvas a la même dimension que la video
      this.canvasContext.drawImage(this.video, 0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
    }
  }

  // est appelé à chaque frame de la lecture de la vidéo
  // dessine l'image de la vidéo et fait avancer le curseur de lecture vidéo
  private afficherDansCanvas(): void {
    this.interval = setInterval(() => {
      this.UpdateSliderRange();
      // fonction drawImage non exécuté dans le cas d'un audio (mp3)
      if (!this.video.src.endsWith('mp3')) {
        this.DrawImage();
      }

    }, 20);
  }

  // regarde si le navigateur utilisé est IE ou un Edge avant le noyau chromium
  // pour déterminer ensuite quelle méthode utiliser pour passer en fullscreen
  private isOlderEdgeOrIE(): boolean {
    return (
      window.navigator.userAgent.indexOf("MSIE ") > -1 ||
      !!navigator.userAgent.match(/Trident.*rv\:11\./) ||
      window.navigator.userAgent.indexOf("Edge") > -1
    );
  }
  //#endregion
}


